import React, { useEffect, useRef } from "react";
import "../home.css";

const stories = [
  {
    quote:
      "ACADME transformed my career. The internship program landed me a job at my dream company. The mentorship was invaluable! The courses are practical and industry-focused. I learned more in ",
    stars: 5,
    author: "Rahul Verma",
    role: "Full Stack Developer at TechCorp",
    initials: "RV",
  },
  {
    quote:
      "The courses are practical and industry-focused. I learned more in 3 months here than in my entire degree program. The courses are practical and industry-focused. I learned more in 3 months here than in my entire degree program. ",
    stars: 5,
    author: "Ananya Patel",
    role: "Data Scientist at DataFlow",
    initials: "AP",
  },
  {
    quote:
      "Best investment in my career. The mentor sessions and real projects gave me the confidence to switch careers successfully. The courses are practical and industry-focused. I learned more in 3 months here than in my entire degree program.",
    stars: 5,
    author: "Arjun Singh",
    role: "Cybersecurity Analyst",
    initials: "AS",
  },
  {
    quote:
      "The learning path was clear, the support was amazing, and the results speak for themselves. Highly recommended! The courses are practical and industry-focused. I learned more in 3 months here than in my entire degree program.",
    stars: 5,
    author: "Sneha Reddy",
    role: "AI Engineer at InnovateTech",
    initials: "SR",
  },
];

const StarRow = ({ count }) => (
  <span className="story-stars">
    {[...Array(count)].map((_, i) => (
      <span key={i}>★</span>
    ))}
  </span>
);

function SuccessPage() {
  const sliderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    document.querySelectorAll(".story-card").forEach((card) => {
      observer.observe(card);
    });
  }, []);

  return (
    <div className="bg-gray-100 pt-3 pb-12">
      <div className="story-title font-black">
        Success <span className="story-highlight">Stories</span>
      </div>
      <div className="story-desc">
        They came to learn. They stayed to grow. Their stories show what happens when ambition meets opportunity.
      </div>

      <div className="slider-container">
        <div className="slider-track" ref={sliderRef}>
          {[...stories, ...stories, ...stories].map((s, i) => (
            <div className="story-card slider-card" key={i}>
              <StarRow count={s.stars} />
              <div className="story-author-row">
                <div className="story-author-info">
                  <span className="story-author-name">{s.author}</span>
                  <span className="story-author-role">{s.role}</span>
                </div>
              </div>
              <div className="story-card-quote">{s.quote}</div>

              {/* <div className="story-author-row">
                <div className="story-author-info">
                  <span className="story-author-name">{s.author}</span>
                  <span className="story-author-role">{s.role}</span>
                </div>
              </div> */}
            </div>
          ))}
        </div>
      </div>

      <div className="success-subscribe-box">
        <div className="success-subscribe-icon">
          <svg
            width="44"
            height="44"
            fill="none"
            viewBox="0 0 24 24"
            stroke="#20bbfe"
            strokeWidth="2"
          >
            <rect x="3" y="7" width="18" height="10" rx="3" />
            <path d="M3 7l9 7 9-7" />
          </svg>
        </div>

        <div className="success-subscribe-title">
          Join <span className="success-subscribe-highlight">10,000+ </span>
          Learners
        </div>

        <div className="success-subscribe-desc">
          Get weekly insights, course updates, and exclusive offers delivered to
          your inbox.
        </div>

        <form
          className="success-subscribe-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <input
            type="email"
            className="success-subscribe-input"
            placeholder="Enter your email"
            required
          />
          <button className="success-subscribe-btn" type="submit">
            Subscribe
          </button>
        </form>

        <div className="success-subscribe-note">
          No spam. Unsubscribe anytime. We respect your privacy.
        </div>
      </div>
    </div>
  );
}

export default SuccessPage;
